import React, { useEffect, useRef, useState } from 'react';
import { EventService } from '../../models/event-service';
import "./showevents.scss";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import InlineFeedback from "../inlinefeedback/inlinefeedback";
import { SUBMENU } from '../../constants';
import OMEGA from '../../omega';

export default function ShowEvents(props:any) {
    const histroyAPI = useHistory();
    const [selectedEvent, setSelectedEvent] = useState("");

const initialFilterState = useRef({

    findLast7DaysEvents: props.state.findLast7DaysEvents,
    findLast40DaysEvents: props.state.findLast40DaysEvents,
    findEventId: props.state.findEventId,
    eventprop: props.state.eventprop,
    ongoingEvents: props.state.ongoingEvents
});

    const eventDefaultValue = {
        element: "Show Events",
        action: "error",
        type: "Component",
        widget: {
            name: "showevents",
            type: "component"
        }
    }

    function omega_capture(element: any, widget_name: any, widget_type: any) {
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            element: element,
            widget: {
                name: widget_name,
                type: widget_type
            },
        }]);
    }

 function redirectEvent(url: any, type?:any) {
       if(type === "product"){
        histroyAPI.push({
            pathname: url,
            state: {
                tab: "events",
                eventType: "all"
            }
        });
       }else{
        histroyAPI.push(url);
       }
    }

  const [ongoingCSOs, setOngoingCSOs] = useState([]);
  const [historicCSOs, setHistoricCSOs] = useState([]);
  const [ongoingCMRs, setOngoingCMRS] = useState([]);
  const [historicCMRs, setHistoricCMRs] = useState([]);
  const [last7DaysEvents, setLast7DaysEvents] = useState([]);
  const [last40DaysEvents, setLast40DaysEvents] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);
  const[onGoingEvents, setOnGoingEvents] = useState(initialFilterState.current.eventprop || []);
  
  const[historicEvents, setHistoricEvents] = useState([]);
    const [loading, setLoading] = useState(true);
  const [hasRedirected, setHasRedirected] = useState(false);
  const eventService: EventService = EventService.init();
 
function redirectProduct(productId:any, eventId:any,  eventType?:any, cloudname?:any){
 
   if(eventType === "Global"){
    redirectEvent(`/global/${eventId}`);
   }else if(eventType === "Cloud"){
    const cloudName = cloudname ? SUBMENU.filter((menu: any) => menu.name === cloudname)[0]?.path : "";
    redirectEvent(`${cloudName}/${eventId}`);
   }else{
    redirectEvent(`/products/${productId}/${eventId}`,"product");
   }
  }
 

function createFlatEventList(events: any) {
  return events?.flatMap((eventObj: any) =>
    eventObj.productInfo.map((product: any) => ({
      id: eventObj.value,
      name: eventObj.label,
      productId: product.productId,
      productName: product.productName,
      start: product?.start,
      ended: product?.ended,
      updated: product?.updated,
      eventType: product.eventType,
      cloudName: product.cloudName
    }))
  );
}

const showMore = () => {
    setVisibleCount((prevCount) => {return Math.min(prevCount + 3, onGoingEvents.length)});
  };
  
const showMoreEvents = (events:any) =>{
 setVisibleCount((prevCount) => {return Math.min(prevCount + 3, events.length)});
}

const showMoreHistoric = () => {
    setVisibleCount((prevCount) => {return Math.min(prevCount + 3, historicEvents.length)});
  };

  const showMoreLast7DaysEvents = () => {
    setVisibleCount((prevCount) => {return Math.min(prevCount + 3, last7DaysEvents.length)});
  };

  const showMoreLast40DaysEvents = () => {
    setVisibleCount((prevCount) => {return Math.min(prevCount + 3, last40DaysEvents.length)});
  };

 useEffect(()=>{
        
    const [servicePromise]: any = [eventService.fetch()];
    Promise.all([servicePromise])
      .then(() => {

            if (props.state.findOngoingCSOs || props.state.findOngoingCMRs) {
                let ongoingEvents:any = eventService.getOnGoingEventsByType();
                let ongoingCSOs = ongoingEvents.filter((event:any)=>!event.type.includes("maintenance"));
                let ongoingCMRs = ongoingEvents.filter((event:any)=>event.type.includes("maintenance"));
                let allOngoingCSOs:any = [];
                ongoingCSOs.forEach((cso:any)=>{cso.list.forEach((csoEvent:any)=>{allOngoingCSOs.push(csoEvent)})});
                let allOngoingCMRs:any = [];
                ongoingCMRs.forEach((cmr:any)=>{cmr.list.forEach((cmrEvent:any)=>{allOngoingCMRs.push(cmrEvent)})});
                  let filteredOngoingCSOs: any  =  [], filteredOngoingCMRs: any = [];
                if((props.state.findOngoingCSOs||props.state.findOngoingCMRs) && props.state?.regionprop?.length && props.state?.myCustomProperty?.length){
                    let tempregArr:  any =[];
                    let tempPrdArr:  any = [];
                    props.state.regionprop.forEach((region:any)=>{if(region.label==="All"){tempregArr = region.value}else{tempregArr.push(region.value)}});
                    props.state.myCustomProperty.forEach((prd:any)=>{tempPrdArr.push(prd.value)});
                    allOngoingCSOs.forEach((cso:any)=>{
                            if(cso.regions  && Object.keys(cso.regions).length){
                                if(Object.keys(cso.regions).some(value => tempregArr.includes(value))){
                                    if(tempPrdArr.length && tempPrdArr.includes(cso.productId)){
                                        filteredOngoingCSOs.push(cso);
                                    }
                                
                                }
                            }

                    })
                    allOngoingCMRs.forEach((cmr:any)=>{
                            if(cmr.regions  && Object.keys(cmr.regions).length){
                                if(Object.keys(cmr.regions).some(value => tempregArr.includes(value))){
                                    if(tempPrdArr.length && tempPrdArr.includes(cmr.productId)){
                                        filteredOngoingCMRs.push(cmr);
                                    }
                                
                                }
                            }

                    })

                }else{

                    filteredOngoingCSOs = allOngoingCSOs;
                    filteredOngoingCMRs = allOngoingCMRs;
                }

                setOngoingCSOs(filteredOngoingCSOs);
                setOngoingCMRS(filteredOngoingCMRs);
                setOnGoingEvents(props.state.findOngoingCSOs?filteredOngoingCSOs:filteredOngoingCMRs);
            }
            if(props.state.findhistoricCSOs || props.state.findhistoricCMRs || initialFilterState.current.findLast7DaysEvents || initialFilterState.current.findLast40DaysEvents){
                const currentDate = new Date();
                const pastDate = new Date();
                const pastDate40 = new Date();

          
                pastDate.setDate(currentDate.getDate() - 7);
                pastDate40.setDate(currentDate.getDate() - 40);
                const pastDateStr = moment(pastDate).format("YYYY-MM-DD");
                const currentDateStr = moment(currentDate).format("YYYY-MM-DD");
                const pastDate40Str = moment(pastDate40).format("YYYY-MM-DD");
                let filterObj = {
                    "products": "",
                    "offerings": [],
                    "regions": [],
                    "environments": [],
                    "date": [
                        pastDateStr,
                        currentDateStr
                    ]
                }
                let statusObj = {
                    "value": "all",
                    "label": "All Status"
                }

                let filterObj40 = {
                    "products": "",
                    "offerings": [],
                    "regions": [],
                    "environments": [],
                    "date": [pastDate40Str, currentDateStr]
                }
                let allhistoricCMRs:any = [], allhistoricCSOs:any = [], allLast7DaysEvents:any = [], allLast40DaysEvents:any = [];
                let historicEventDates: any = eventService.getIncidentsByDate(filterObj, "all","all",statusObj,undefined,undefined,true)
                historicEventDates.forEach((eventDate:any)=>{
                        eventDate.incidents.forEach((event:any)=>{
                            allLast7DaysEvents.push(event);
                            if(event.eventType.includes("maintenance")){
                                allhistoricCMRs.push(event);
                            }else{
                                allhistoricCSOs.push(event);}

                            })
                });


                let historicEventDates40 = eventService.getIncidentsByDate(filterObj40, "all","all",statusObj,undefined,undefined,true);
                historicEventDates40.forEach((eventDate:any)=>{
                        eventDate.incidents.forEach((event:any)=>{
                            allLast40DaysEvents.push(event);
                        })
                });



                
                 let filteredHistoricCSOs: any  =  [], filteredHistoricCMRs: any = [], filteredLast7DaysEvents: any = [], filteredLast40DaysEvents: any = [];
                if((props.state.findhistoricCSOs||props.state.findhistoricCMRs||initialFilterState.current.findLast7DaysEvents || initialFilterState.current.findLast40DaysEvents) && props.state?.regionprop?.length && props.state?.myCustomProperty?.length){
                    let tempregArr:  any =[];
                    let tempPrdArr:  any = [];
                    props.state.regionprop.forEach((region:any)=>{if(region.label==="All"){tempregArr = region.value}else{tempregArr.push(region.value)}});
                    props.state.myCustomProperty.forEach((prd:any)=>{tempPrdArr.push(prd.value)});


                    allhistoricCSOs.forEach((cso:any)=>{
                            if(cso.regions  && Object.keys(cso.regions).length){
                                if(Object.keys(cso.regions).some(value => tempregArr.includes(value))){
                                    if(tempPrdArr.length && tempPrdArr.includes(cso.productId)){
                                        filteredHistoricCSOs.push(cso);
                                    }
                                
                                }
                            }

                    })
                    allhistoricCMRs.forEach((cmr:any)=>{
                            if(cmr.regions  && Object.keys(cmr.regions).length){
                                if(Object.keys(cmr.regions).some(value => tempregArr.includes(value))){
                                    if(tempPrdArr.length && tempPrdArr.includes(cmr.productId)){
                                        filteredHistoricCMRs.push(cmr);
                                    }
                                
                                }
                            }

                    })

                    allLast7DaysEvents.forEach((event:any)=>{
                        var regionExists = false;
                        if((event.regions && Object.keys(event.regions).length)){
                            if(Object.keys(event.regions).some(value => tempregArr.includes(value))){
                                regionExists = true;
                            }
                        }
                        if(regionExists || event.eventType ==="potential" || event.eventType==="Global" || event.eventType==="Cloud" || event.eventType==="Product"){
                            if(tempPrdArr.length && tempPrdArr.includes(event.productId)){
                                filteredLast7DaysEvents.push(event);
                            }
                        }
                    })
                    allLast40DaysEvents.forEach((event:any)=>{
                        var regionExists = false;
                        if(event.regions  && Object.keys(event.regions).length){
                            if(Object.keys(event.regions).some(value => tempregArr.includes(value))){
                                regionExists = true;
                            }
                        }
                        if(regionExists || event.eventType ==="potential" || event.eventType==="Global" || event.eventType==="Cloud" || event.eventType==="Product"){
                            if(tempPrdArr.length && tempPrdArr.includes(event.productId)){
                                filteredLast40DaysEvents.push(event);
                            }
                        }
                    })

                }else{
                    filteredHistoricCSOs = allhistoricCSOs;
                    filteredHistoricCMRs = allhistoricCMRs;
                    filteredLast7DaysEvents = allLast7DaysEvents;
                    filteredLast40DaysEvents = allLast40DaysEvents;
                }
                



                filteredHistoricCSOs = filteredHistoricCSOs.filter(
                (item:any, index:any, self:any) =>
                    index ===
                    self.findIndex(
                    (t:any) => t.incidentId === item.incidentId && t.productId === item.productId
                    )
                );
                 filteredHistoricCMRs = filteredHistoricCMRs.filter(
                (item:any, index:any, self:any) =>
                    index ===
                    self.findIndex(
                    (t:any) => t.incidentId === item.incidentId && t.productId === item.productId
                    )
                );
                filteredLast7DaysEvents = filteredLast7DaysEvents.filter(
                (item:any, index:any, self:any) =>
                    index ===
                    self.findIndex(
                    (t:any) => t.incidentId === item.incidentId && t.productId === item.productId
                    )
                );
                filteredLast40DaysEvents = filteredLast40DaysEvents.filter(
                (item:any, index:any, self:any) =>
                    index ===
                    self.findIndex(
                    (t:any) => t.incidentId === item.incidentId && t.productId === item.productId
                    )
                );
                setHistoricCSOs(filteredHistoricCSOs);
                setHistoricCMRs(filteredHistoricCMRs);
                setLast7DaysEvents(filteredLast7DaysEvents);
                setLast40DaysEvents(filteredLast40DaysEvents);
                setHistoricEvents(props.state.findhistoricCSOs?filteredHistoricCSOs:filteredHistoricCMRs);
            }
             setLoading(false);
              })
              .catch((error: any) => {
                console.error('Error in showevents fetching events:', error);
                omega_capture(
                    `Error in showevents fetching events: ${error.message || error.toString()}`,
                    "showevents",
                    "error"
                );
                setLoading(false);
              });

    },[]);

    // Auto-redirect when there's only one event (only once when component loads)
    useEffect(() => {
        if (!loading && initialFilterState.current.findEventId && initialFilterState.current.eventprop && !hasRedirected) {
            const flatEventList = createFlatEventList(initialFilterState.current.eventprop);
            
            if (flatEventList && flatEventList.length === 1) {
                const singleEvent = flatEventList[0];
                const targetPath = `/products/${singleEvent.productId}/${singleEvent.id}`;
                const currentPath = histroyAPI.location.pathname;
                
                if (currentPath !== targetPath) {
                    setHasRedirected(true);
                    redirectProduct(singleEvent.productId, singleEvent.id, singleEvent.eventType, singleEvent.cloudName);
                }
            }
        }
    }, [loading, hasRedirected]);

function restart(){
return <div className='restart-container'>
    

    <button 
        className="show-more-link  restart-workflow back-arrow-button" 
        onClick={props.actionProvider.handleFindEvents}
        title="Go back"
        aria-label="Go back"
        data-tooltip="Go back"
    >
    </button>

    <button 
        className="show-more-link restart top-arrow-button" 
        onClick={props.actionProvider.handleOptions}
        title="Start from top"
        aria-label="Start from top"
        data-tooltip="Start from top"
    >
    </button>

    <InlineFeedback conversationId={props.conversationId} />
</div>
}
function getOngoingCSOs(type:any){
let ongoingEvents = type === "CSO"? ongoingCSOs: ongoingCMRs;
const eventType = type === "CSO" ? "ongoing issues" : "ongoing maintenance";

return <div>
  <div role="group" aria-label={`${eventType} navigation`}>
    {ongoingEvents.slice(0, visibleCount).map((csoEvent:any,index:any)=>{
      return <div key={index}>
        <button 
          onClick={()=>{
            setSelectedEvent(`${csoEvent.name} | ${type === "CSO" ? "Issue" : "Maintenance"} #${csoEvent.incidentId}`);
            redirectProduct(csoEvent.productId,csoEvent.incidentId);
          }} 
          className="events-button"
          aria-describedby={`event-${index}-description`}
        >
          {csoEvent.name} | {type === "CSO" ? "Issue" : "Maintenance"} #{csoEvent.incidentId}
        </button>
        <div id={`event-${index}-description`} className="sr-only">
          Navigate to event details for {csoEvent.name}
        </div>
      </div>
    })}
    {selectedEvent && (
      <div aria-live="polite" className="sr-only">
        Navigating to: {selectedEvent}
      </div>
    )}
  </div>
  {visibleCount < ongoingEvents?.length && (
    <button 
      className="show-more-link" 
      onClick={showMore}
      aria-label={`Show more ${eventType}`}
    >
      Show More
    </button>
  )}
  {restart()}
</div>
}

function getEvents(events:any){
const flatEventList = createFlatEventList(events);






let ongoingEvents = flatEventList;

return <div>
{flatEventList?.slice(0, visibleCount).map((csoEvent:any,index:any)=>{
  
    return <div><button key={index} onClick={()=>redirectProduct(csoEvent.productId,csoEvent.id, csoEvent.eventType, csoEvent.cloudName)} className="events-button">
        {csoEvent.productName} | {getDate(csoEvent)} | {csoEvent.id.includes("CHG")?`Maintenance #${csoEvent.id}`:`Issue #${csoEvent.id}`}
        </button>
        
        </div>
        
   
})}
{visibleCount < ongoingEvents?.length && (
        <button className="show-more-link" onClick={() => showMoreEvents(flatEventList)} >
          Show More
        </button>
      )}
{restart()}
</div>
}

function getHistoricCSOs(type:any){
let historicEvents = type === "CSO"? historicCSOs: historicCMRs;
const eventType = type === "CSO" ? "historic issues" : "historic maintenance";

return <div>
  <div role="group" aria-label={`${eventType} navigation`}>
    {historicEvents.slice(0, visibleCount).map((csoEvent:any,index:any)=>{
      return <div key={index}>
        <button 
          onClick={()=>{
            setSelectedEvent(`${csoEvent.name} | ${type === "CSO" ? "Issue" : "Maintenance"} #${csoEvent.incidentId}`);
            redirectProduct(csoEvent.productId,csoEvent.incidentId);
          }} 
          className="events-button"
          aria-describedby={`historic-event-${index}-description`}
        >
          {csoEvent.name} | {type === "CSO" ? "Issue" : "Maintenance"} #{csoEvent.incidentId}
        </button>
        <div id={`historic-event-${index}-description`} className="sr-only">
          Navigate to historic event details for {csoEvent.name}
        </div>
      </div>
    })}
    {selectedEvent && (
      <div aria-live="polite" className="sr-only">
        Navigating to: {selectedEvent}
      </div>
    )}
  </div>
  {visibleCount < historicEvents.length && (
    <button 
      className="show-more-link" 
      onClick={showMoreHistoric}
      aria-label={`Show more ${eventType}`}
    >
      Show More
    </button>
  )}
  {restart()}
</div>
}
function getDate(csoEvent:any){
    if(csoEvent.ended){
        return csoEvent.ended;
    }else if(csoEvent.updated){
        return csoEvent.updated;
    }else{
        return csoEvent.start;
    }
}

function getLast7DaysEvents(){

return <div>{last7DaysEvents.slice(0, visibleCount).map((csoEvent:any,index:any)=>{
    return <div><button key={index} onClick={()=>redirectProduct(csoEvent.productId,csoEvent.incidentId, csoEvent.eventType, csoEvent.cloudName)} className="events-button">
        {props.state.myCustomProperty? "":`${csoEvent.name} |` }{csoEvent.eventType==="Cloud"?(` ${csoEvent.cloudName} | `):""}{getDate(csoEvent)} | {csoEvent.eventType==="Global" ||csoEvent.eventType==="Cloud" || csoEvent.eventType==="Product"?"Announcement": csoEvent.eventType==="maintenance"?"Change":"Issue"} #{csoEvent.incidentId}
        </button>

        </div>
})}
{visibleCount < last7DaysEvents.length && (
        <button className="show-more-link" onClick={showMoreLast7DaysEvents} >
          Show More
        </button>
      )}
{restart()}
</div>
}

function getLast40DaysEvents(){
    return <div>{last40DaysEvents.slice(0, visibleCount).map((csoEvent:any,index:any)=>{
        return <div><button key={index} onClick={()=>redirectProduct(csoEvent.productId,csoEvent.incidentId, csoEvent.eventType , csoEvent.cloudName)} className="events-button">
            {props.state.myCustomProperty? "":`${csoEvent.name} |` }{getDate(csoEvent)} | {csoEvent.eventType==="Global" ||csoEvent.eventType==="Cloud" || csoEvent.eventType==="Product"?"Announcement": csoEvent.eventType==="maintenance"?"Change":"Issue"} #{csoEvent.incidentId}
            </button>

            </div>
})}
{visibleCount < last40DaysEvents.length && (
        <button className="show-more-link" onClick={showMoreLast40DaysEvents} >
          Show More
        </button>
      )}
{restart()}
</div>
}

        

  return (
    // <div>{loading?"loading...":
    // props.state.findOngoingCSOs?
    //         ongoingCSOs.length? <div>
    //         {getOngoingCSOs("CSO")}
    //         </div>:<div>No ongoing issues{restart()}</div>
    //     :props.state.findOngoingCMRs?ongoingCMRs.length?<div> {getOngoingCSOs("CMR")}</div>:<div>No ongoing maintenances{restart()}</div>
    //     :
    // props.state.findhistoricCSOs?
    //         historicCSOs.length? <div>
    //         {getHistoricCSOs("CSO")}
    //         </div>:<div>No events match your criteria {restart()}</div>
    //     :props.state.findhistoricCMRs?historicCMRs.length?<div> {getHistoricCSOs("CMR")}</div>:<div>No historic maintenances{restart()}</div>
    //     :props.state.findEventId && props.state.ongoingEvents?<>{getEvents(props.state.eventprop)}</>:props.state.findLast7DaysEvents?last7DaysEvents.length?<>{getLast7DaysEvents()}</>:<div>No events match your criteria {restart()}</div>:<div>No events match your criteria {restart()}</div>}
    // </div>




    <div>{loading?"loading...":
    initialFilterState.current.findLast7DaysEvents || initialFilterState.current.findLast40DaysEvents || initialFilterState.current.findEventId? 
            initialFilterState.current.findLast7DaysEvents && last7DaysEvents.length? 
                <div>
                {getLast7DaysEvents()}
                </div>
            :initialFilterState.current.findLast40DaysEvents && last40DaysEvents.length?
                <div>
                {getLast40DaysEvents()}
                </div>
            :initialFilterState.current.findEventId && initialFilterState.current.ongoingEvents?
            <>{getEvents(initialFilterState.current.eventprop)}</>
            :<>No events match your criteria {restart()}</>:<></>
    }
    </div>
  );
}